import React from 'react';

const DateStrip = ({ days, selectedDate, onSelectDate, isSameDay, getDateLabel }) => (
  <div className="relative mb-6 overflow-x-auto no-scrollbar snap-x snap-mandatory overscroll-contain">
    <div className="flex gap-2 w-max pb-1">
      {days.map((day, i) => {
        const isActive = selectedDate && isSameDay(selectedDate, day.date);
        const isToday = i === 0;
        return (
          <button
            key={i}
            onClick={() => onSelectDate(isActive ? null : day.date)}
            className={`flex-shrink-0 snap-start w-16 py-2.5 rounded-2xl text-center border transition-all duration-200 ${
              isActive
                ? 'bg-[#1d5cab] text-white border-[#1d5cab] shadow-md'
                : isToday
                  ? 'bg-blue-50 border-blue-200 text-gray-900'
                  : 'bg-white border-gray-200 text-gray-700 hover:border-gray-300'
            }`}
          >
            <div className={`text-[10px] font-bold uppercase leading-none ${isActive ? 'text-blue-100' : 'text-gray-400'}`}>
              {getDateLabel(day.date, i)}
            </div>
            <div className={`text-xl font-black leading-tight mt-0.5 ${isActive ? 'text-white' : ''}`}>
              {day.date.getDate()}
            </div>
            {day.hasEvents && (
              <div className={`w-1.5 h-1.5 rounded-full mx-auto mt-1 ${isActive ? 'bg-white' : 'bg-[#1d5cab]'}`} />
            )}
          </button>
        );
      })}
    </div>
    <div className="absolute right-0 top-0 bottom-0 w-8 bg-gradient-to-l from-white to-transparent pointer-events-none" />
  </div>
);

export default DateStrip;
